import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getNhDealApplicationId } from "features/authSlice";
import { getLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { useGetloanOfficerQuery, type LoanOfficerDetail } from "pages/application/applicationService";

/** Redux may hold an empty DTO from before LO assignment; only skip refetch when we already have a real LO. */
function hasAssignedLoanOfficer(lo: LoanOfficerDetail | null | undefined): boolean {
  if (!lo) return false;
  const name = (lo.fullName ?? lo.name ?? "").trim();
  return name.length > 0;
}

export const useLoanOfficer = () => {
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const loanOfficerFromCache = useSelector(getLoanOfficerDetail);

  const {
    data: loanOfficerFromApi,
    isLoading,
    isSuccess,
    error,
  } = useGetloanOfficerQuery(nhDealApplicationId, {
    skip: !nhDealApplicationId || hasAssignedLoanOfficer(loanOfficerFromCache),
    refetchOnMountOrArgChange: true,
  });

  const loanOfficer = useMemo(() => {
    return loanOfficerFromCache ?? loanOfficerFromApi;
  }, [loanOfficerFromCache, loanOfficerFromApi]);

  return {
    loanOfficer,
    isLoading,
    isSuccess,
    error,
    hasLoanOfficer: !!loanOfficer
  };
};
